module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.6d273137.jpeg";